import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../display/theme/tokens.css';
import '../display/theme/base.css';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
